import { isDevPublicSiteHost } from '../urls/publicSiteHost.js';

export type StudioAmericonDashboardProduct = 'apt_studio' | 'americon';

export const VITE_APT_STUDIO_PROD_PUBLISHED_ENV = 'VITE_APT_STUDIO_PROD_PUBLISHED';
export const VITE_AMERICON_PROD_PUBLISHED_ENV = 'VITE_AMERICON_PROD_PUBLISHED';

/**
 * Dev / QA hosts where APT Studio + AmeriCon dashboard modules may open
 * before production publish.
 */
export function isStudioAmericonDashboardDevRuntime(args: {
  hostname?: string | null;
  port?: string | null;
  viteDev?: boolean;
}): boolean {
  if (args.viteDev === true) {
    return true;
  }
  const hostname = (args.hostname ?? '').trim().toLowerCase();
  const port = (args.port ?? '').trim();
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return true;
  }
  if (port === '5173' || port === '5174') {
    return true;
  }
  if (hostname && isDevPublicSiteHost(hostname)) {
    return true;
  }
  return false;
}

export function isStudioAmericonDashboardProdPublished(
  product: StudioAmericonDashboardProduct,
  env: Record<string, string | undefined> = {},
): boolean {
  if (product === 'apt_studio') {
    return env[VITE_APT_STUDIO_PROD_PUBLISHED_ENV] === 'true';
  }
  return env[VITE_AMERICON_PROD_PUBLISHED_ENV] === 'true';
}

/**
 * Whether the dashboard may navigate into Studio / AmeriCon (vs Coming Soon).
 * Feature flags (`VITE_*_ENABLED`) still control tab visibility separately.
 */
export function canOpenStudioAmericonDashboardProduct(
  product: StudioAmericonDashboardProduct,
  args: {
    hostname?: string | null;
    port?: string | null;
    viteDev?: boolean;
    env?: Record<string, string | undefined>;
  } = {},
): boolean {
  if (
    isStudioAmericonDashboardDevRuntime({
      hostname: args.hostname,
      port: args.port,
      viteDev: args.viteDev,
    })
  ) {
    return true;
  }
  return isStudioAmericonDashboardProdPublished(product, args.env ?? {});
}

export function isStudioAmericonDashboardProductKey(
  key: string,
): key is StudioAmericonDashboardProduct {
  return key === 'apt_studio' || key === 'americon';
}
